import React from 'react'
import "./Footer.css"
import { Link as LinkS } from 'react-scroll'
import footerImg1 from "../../Assets/fHome.avif"
import footerImg2 from "../../Assets/fAbout.avif"
import footerImg3 from "../../Assets/fExp.avif"
import footerImg4 from "../../Assets/fServ.avif"
import footerImg5 from "../../Assets/fGallery.avif"
import footerImg6 from "../../Assets/fGalleryPage.avif"
import { Link } from 'react-router-dom'
const Footer = () => {
    return (
        <div id='Footer'>

            <h2 style={{
                marginTop: "4rem",
                width: "100%",
                textAlign: "center",
                color: "#aa9e8f"
            }}>Fast Links</h2>
            <div className="grid image-grid">
                <div className="grid-block">
                    <div className="tile">
                        <LinkS smooth={true} duration={1500} className="tile-link" to="Header">
                            <img className="tile-img tile-img1" src={footerImg1} alt="img" />
                            <h4>Home</h4>
                        </LinkS>
                    </div>
                </div>

                <div className="grid-block">
                    <div className="tile">
                        <LinkS smooth={true} duration={1500} className="tile-link" to="about__me">
                            <img className="tile-img tile-img2" src={footerImg2} alt="img" />
                            <h4>About Me</h4>
                        </LinkS>
                    </div>
                </div>

                <div className="grid-block">
                    <div className="tile">
                        <LinkS smooth={true} duration={1500} className="tile-link" to="experiense">
                            <img className="tile-img tile-img3" src={footerImg3} alt="img" />
                            <h4>Experiense</h4>
                        </LinkS>
                    </div>
                </div>

                <div className="grid-block">
                    <div className="tile">
                        <LinkS smooth={true} duration={1500} className="tile-link" to="services">
                            <img className="tile-img tile-img4" src={footerImg4} alt="img" />
                            <h4>Services</h4>
                        </LinkS>
                    </div>
                </div>
                <div className="grid-block">
                    <div className="tile">
                        <LinkS smooth={true} duration={1500} className="tile-link" to="Galleryy">
                            <img className="tile-img tile-img4" src={footerImg5} alt="img" />
                            <h4>Gallery</h4>
                        </LinkS>
                    </div>
                </div>
                <div className="grid-block">
                    <div className="tile">
                        <Link smooth="true" duration={1500} className="tile-link" to="/Gallery">
                            <img className="tile-img tile-img4" src={footerImg6} alt="img" />
                            <h4>Gallery Page</h4>
                        </Link>
                    </div>
                </div>


            </div>
        </div>
    )
}

export default Footer